import { createBuilderModule } from '../../../register-builder/builder-module';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { TestimonialMultipleColumn } from './TestimonialMultipleColumn';
import { COLOR_KEYS } from '../../../constants';
import { DEFAULT_VALUES } from './fixtures';

export default createBuilderModule(
  withTracking(TestimonialMultipleColumn, {
    as: 'section',
    sectionName: SectionName.TestimonialMultipleColumn,
  }),
  {
    name: 'TestimonialMultipleColumn',
    image: 'https://cdn.zappy.app/ec91521a8eb8a2bdc6baa02fa86d99f8.png',
    inputs: [
      {
        name: 'numberOfColumns',
        type: 'number',
        required: true,
        defaultValue: DEFAULT_VALUES.numberOfColumns,
      },
      {
        name: 'testimonials',
        type: 'list',
        required: true,
        defaultValue: DEFAULT_VALUES.testimonials,
        subFields: [
          {
            name: 'quote',
            type: 'richText',
            required: true,
          },
          {
            name: 'author',
            type: 'string',
            required: true,
          },
          {
            name: 'company',
            type: 'string',
            required: true,
          },
          {
            name: 'hasAuthorAvatar',
            type: 'boolean',
          },
          {
            name: 'avatarUrl',
            type: 'cloudinaryImage',
          },
        ],
      },
      {
        name: 'backgroundColor',
        type: 'string',
        defaultValue: DEFAULT_VALUES.backgroundColor,
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
      },
    ],
  },
);
